var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatarUser = function SvgAvatarUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 0,
    height: 0,
    fill: "none",
    viewBox: "0 0 20 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.588 22c-.96 0-1.758-.69-1.557-1.512q.195-.797.59-1.55c.51-.97 1.258-1.852 2.2-2.595a10.7 10.7 0 0 1 3.294-1.734A12.6 12.6 0 0 1 10 14c1.333 0 2.653.207 3.885.609s2.35.991 3.293 1.734 1.69 1.625 2.201 2.596c.263.5.46 1.02.59 1.549.2.823-.596 1.512-1.557 1.512zM16 6A6 6 0 1 1 4 6a6 6 0 0 1 12 0"
  })));
};
export default SvgAvatarUser;